// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@keller/XDL/types";
import { css } from "styled-components";

export const fontConfig = {
    url: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap",
    weight: {
        regular: 400,
        bold: 700,
        black: 900,
    },
    fontFamily: "'Lato', sans-serif, 'Roboto'",
};

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "15px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
    },
    p: {
        size: "15px",
        weight: 400,
        css: css`
            margin-bottom: 20px;
            display: block;
        `,
    },
    h1: {
        size: "32px",
        weight: fontConfig.weight.black,
        css: css`
            line-height: 40px;
            margin-bottom: 20px;
            display: block;
        `,
    },
    h2: {
        size: "28px",
        weight: fontConfig.weight.black,
        css: css`
            line-height: 34px;
            margin-bottom: 16px;
            display: block;
        `,
    },
    h3: {
        size: "24px",
        weight: fontConfig.weight.black,
        css: css`
            line-height: 30px;
            margin-bottom: 12px;
            display: block;
        `,
    },
    h4: {
        size: "20px",
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 25px;
            margin-bottom: 12px;
            display: block;
        `,
    },
    h5: {
        size: "18px",
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 22px;
            margin-bottom: 12px;
            display: block;
        `,
    },
    h6: {
        size: "14px",
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 19px;
            margin-bottom: 12px;
            display: block;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
        weight: fontConfig.weight.black,
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        transform: "uppercase",
        weight: fontConfig.weight.black,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.main",
        transform: "uppercase",
        weight: fontConfig.weight.bold,
    },
} as xBaseTheme["typography"];
